<p translate="error-renderer-course-license-expired-main-message"></p>

<p class="small" translate="activity-creation_contact-license-manager-to-renew-license"></p>
